"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var core_2 = require("@21st-night/core");
var editor_web_1 = require("@21st-night/editor-web");
var LoadingIndicator_1 = __importDefault(require("../../LoadingIndicator"));
var RichText_1 = __importDefault(require("../../RichText"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {},
        loader: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 400,
        },
        summary: {
            marginBottom: theme.spacing(2),
        },
        divider: {
            marginTop: theme.spacing(2),
        },
        empty: {
            paddingTop: '10%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
        emptyIconContainer: {
            height: 100,
            width: 100,
            borderRadius: 50,
            backgroundColor: '#ECEFF1',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: theme.spacing(2),
        },
        emptyIcon: {
            width: 60,
            height: 'auto',
            color: '#B0BEC5',
        },
        emptyDescription: {
            maxWidth: 340,
            textAlign: 'center',
        },
    });
});
var DeckCheatSheetView = function (_a) {
    var classNameProp = _a.className, children = _a.children, other = __rest(_a, ["className", "children"]);
    var _b = core_2.useDeckCheatSheet(), subscribe = _b.subscribe, summaries = _b.summaries, loading = _b.loading;
    var classes = exports.useStyles();
    react_1.useEffect(function () {
        subscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.root, classNameProp) }, other),
        !loading && summaries.length > 0 && children,
        loading && (react_1.default.createElement("div", { className: classes.loader },
            react_1.default.createElement(LoadingIndicator_1.default, { size: "large" }))),
        summaries.length > 0 &&
            summaries.map(function (summary) { return (react_1.default.createElement("div", { className: classes.summary },
                react_1.default.createElement(RichText_1.default, { document: editor_web_1.deserializeDocument(summary.content) }),
                react_1.default.createElement(core_1.Divider, { className: classes.divider }))); }),
        !loading && summaries.length === 0 && (react_1.default.createElement("div", { className: classes.empty },
            react_1.default.createElement("div", { className: classes.emptyIconContainer },
                react_1.default.createElement(icons_1.DescriptionOutlined, { className: classes.emptyIcon })),
            react_1.default.createElement(core_1.Typography, { gutterBottom: true, variant: "h6" }, "You don't have any key takeaways"),
            react_1.default.createElement(core_1.Typography, { gutterBottom: true, color: "textSecondary", className: classes.emptyDescription }, "Cheat Sheet combines all of the key takeaways from your error logs for quick and easy reviewing.")))));
};
exports.default = DeckCheatSheetView;
//# sourceMappingURL=DeckCheatSheetView.js.map